// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2b-dF","rootCenter":"LoadMoreObserver_rootCenter__2KyKO","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__mS6Zs"};